import {Component, Inject, OnInit} from '@angular/core';
import {NpaDatabase, NpaDataSource} from '../../classes/npa-table';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {NotificationsService} from '../../services/notifications.service';
import {composeMessage} from "../../consts/errors";
import { NonElectronicProposedContractService } from 'src/app/pages/procurement-process/components/non-electronic-award-decision-notice/non-electronic-proposed-contract.service';
import {MatDialog} from '@angular/material/dialog';
import { VendorTaxClearanceDialogComponent } from '../vendor-tax-clearance-dialog/vendor-tax-clearance-dialog.component';
import { ContextAccessService } from 'src/app/services/context-access.service';

@Component({
    selector: 'show-participant-dialog',
    templateUrl: './show-participants-dialog.component.html',
    styleUrls: ['./show-participants-dialog.component.styl']
})
export class ShowParticipantsDialogComponent implements OnInit {
    displayedColumns: string[] = [ 'id', 'contractor_name', 'v_pin', 'country'];
    dataSource: NpaDataSource;
    database: NpaDatabase;
    isLoading = false;

    constructor(public dialogRef: MatDialogRef<ShowParticipantsDialogComponent>,
                public notificationsService: NotificationsService,
                public dialog: MatDialog,
                private contextAccessService: ContextAccessService,
                private nonElectronicProposedContractService: NonElectronicProposedContractService,
                @Inject(MAT_DIALOG_DATA) public dialogData) {
    }

    ngOnInit() {
        if (this.contextAccessService.can('aets-bid-opening-volunteer-participants', 'context_operation', ['view'])) {
            this.displayedColumns.push("operations");
        }
        this.isLoading = true;
        this.notificationsService.startLoading();
        this.nonElectronicProposedContractService.getParticipants(this.dialogData.tenderRevisionId)
            .subscribe(
                (result) => {
                    this.database = new NpaDatabase(result);
                    this.dataSource = new NpaDataSource(this.database);
                    this.isLoading = false;
                    this.notificationsService.dismissLoading();
                },
                (error) => {
                    this.database = new NpaDatabase([]);
                    this.dataSource = new NpaDataSource(this.database);
                    this.isLoading = false;
                    this.notificationsService.error(composeMessage(error));
                }

            )
    }

    openTaxClearanceDialog(username) {
        this.dialog.open(VendorTaxClearanceDialogComponent, {
            disableClose: true,
            width: '1000px',
            data: {username: username}
        });
    }

}
